<template>
  <div>
    <div class="flex h-13" @mouseover="hoverState = true" @mouseleave="hoverState = false">
      <div class="sticky left-0 z-10 flex pl-6 bg-slate-100">
        <div
          class="flex items-center justify-between flex-shrink-0 px-4 transition-all duration-300 border-b border-l border-r w-80 border-slate-400"
          :class="[
            isLast ? 'rounded-bl' : '',
            hoverState ? 'bg-hover-state' : 'bg-pure-white'
          ]">
          <BlTextBody2 :title="databank.name" :text="databank.name" class="truncate text-slate-1000" />
        </div>
      </div>

      <div class="flex items-center flex-shrink-0 w-40 px-4 transition-all duration-300 border-b border-slate-400"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']">
        <BlIcon v-if="databank.import_status === 'pending'" icon="update" class="w-5 h-5 mr-2 animate-spin" />
        <BlTextBody2
          :text="databank.import_status === 'pending' ? 'importing' : databank.import_status === 'completed' ? databank.total_curriculums : databank.total_curriculums"
          class="truncate" />
      </div>
      <div class="flex items-center flex-shrink-0 w-40 px-4 transition-all duration-300 border-b border-slate-400"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']">
        <BlIcon v-if="databank.import_status === 'pending'" icon="update" class="w-5 h-5 mr-2 animate-spin" />
        <BlTextBody2
          :text="databank.import_status === 'pending' ? 'importing' : databank.import_status === 'completed' ? databank.total_targets : databank.total_targets"
          class="truncate" />
      </div>
      <div class="flex items-center flex-shrink-0 px-4 transition-all duration-300 border-b border-slate-400"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']">
        <BlTextBody2 :text="databank.description || '-'" />
      </div>
      <div
        class="flex items-center justify-end flex-grow flex-shrink-0 gap-2 pl-4 transition-all duration-300 border-b w-72 border-slate-400"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']">
        <BlInputButton type="outlined" dense label="View databank" :loading="submitLoading"
          @clicked="onViewDatabankDetails" />
      </div>
      <div class="sticky right-0 z-10 flex pr-6 bg-slate-100">
        <div
          class="flex items-center justify-center flex-shrink-0 w-12 transition-all duration-300 border-b border-r border-slate-400"
          :class="[
            isLast ? 'rounded-br' : '',
            hoverState ? 'bg-hover-state' : 'bg-pure-white'
          ]">
          <div class="relative">
            <BlInputButton type="plain" dense icon="dots-vertical" class="hover:bg-hover-state"
              @clicked="menuOpened = !menuOpened" />
            <div v-if="menuOpened"
              class="absolute top-0 z-50 flex flex-col gap-1 px-2 py-2 mr-3 border rounded right-full bg-pure-white border-slate-400">
              <div @click="updateOpened = true" class="px-4 py-2 rounded cursor-pointer min-w-40 hover:bg-hover-state">
                <BlTextBody2 text="Edit databank" />
              </div>
              <div class="px-4 py-2 rounded cursor-pointer min-w-40 hover:bg-hover-state" @click="deleteOpened = true">
                <BlTextBody2 class="text-error-400" text="Delete databank" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BlBackdrop v-if="updateOpened" :disabled="isDisabledSubmit" :title="`Edit databank`" :label="`Edit databank`"
      type="primary" @backdrop-close="updateOpened = false" :submitLoading="submitLoading" @backdrop-action="onUpdate">
      <div class="flex flex-col gap-5 px-8 overflow-y-auto"
        :style="{ width: '40rem', maxHeight: 'calc(100vh - 14rem)' }">
        <div class="grid items-center grid-cols-6 gap-4 py-4">
          <BlInputText class="col-span-6" :input="databankNameInput" @changed="inputHandler" />
          <BlInputText class="col-span-6" :input="descriptionInput" @changed="inputHandler" />
        </div>
      </div>
    </BlBackdrop>
    <BlBackdrop v-if="deleteOpened" :title="`Delete databank`" :label="`Delete databank`" type="error"
      @backdrop-close="deleteOpened = false" @backdrop-action="onDelete" :submitLoading="submitLoading">
      <div class="px-8">
        <BlTextBody2 text="Deleting" />
        <BlTextBody2 :text="`${databank.name}`" class="font-bold" />
        <BlTextBody2
          text="will no affect centers that have already used it. Homeover, it will be removed from the Super Admin. This action cannot be undone." />
      </div>
    </BlBackdrop>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import BlTextBody2 from "../../BlTextBody2.vue";
import BlChip from "../../BlChip.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlBackdrop from "../../BlBackdrop.vue";
import BlInputText from "../../BlInputText.vue";
import BlIcon from "../../BlIcon.vue";

export default {
  name: "DatabankItem",
  components: {
    BlTextBody2,
    BlChip,
    BlIcon,
    BlInputButton,
    BlBackdrop,
    BlInputText
  },
  props: {
    databank: { type: Object, required: true },
    isLast: { type: Boolean, default: false }
  },
  data() {
    return {
      hoverState: false,
      menuOpened: false,
      submitLoading: false,
      deactivateOpened: false,
      reactivateOpened: false,
      updateOpened: false,
      deleteOpened: false,
      databankNameInput: {
        label: "Databank name",
        placeholder: "Type name",
        model: this.databank.name,
        asterisk: true
      },
      descriptionInput: {
        label: "Description",
        placeholder: "Type description",
        textarea: true,
        model: this.databank.description
      }
    };
  },
  computed: {
    isDisabledSubmit() {
      if (!this.databankNameInput.model) return true;
      return false;
    }
  },
  watch: {
    menuOpened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      }
    }
  },
  async mounted() { },
  methods: {
    ...mapActions(["moveCurrentUserCenter", "updateDatabank", "deleteDatabank"]),

    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    closeHandler() {
      window.removeEventListener("click", this.closeHandler);
      this.menuOpened = false;
    },
    async onViewDatabankDetails() {
      this.$router.push({
        name: "SuperAdminDatabank",
        params: { id: this.databank.id }
      });
    },

    async onDelete() {
      const params = {
        id: this.databank.id
      };

      this.submitLoading = true;
      const { success } = await this.deleteDatabank(params);
      this.submitLoading = false;
      if (!success) return;
      this.deleteOpened = false;
    },

    async onUpdate() {
      const params = {
        id: this.databank.id,
        databank: {
          name: this.databankNameInput.model,
          description: this.descriptionInput.model
        }
      };
      this.submitLoading = true;
      const { success } = await this.updateDatabank(params);
      this.submitLoading = false;
      if (!success) return;
      this.updateOpened = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/superAdmin/databanks/Item.vue